type SendMessageToUnreal = (message: unknown) => void;

export type HotspotPlacementVariant = '2D' | '3D';

export interface HotspotPlacementPayload {
  brandingHotspotId?: string;
  name?: string;
  roomId?: string;
  type?: string;
  data?: {
    url?: string;
    webBrowserUrl?: string;
    [key: string]: unknown;
  };
}

export const startHotspotPlaceInUnreal = (
  sendMessageToUnreal: SendMessageToUnreal,
  variant: HotspotPlacementVariant,
  payload: HotspotPlacementPayload,
) => {
  sendMessageToUnreal({
    action:
      variant === '3D' ? 'START_HOTSPOT_PLACE_3D' : 'START_HOTSPOT_PLACE_2D',
    ...payload,
  });
};

export const notifyHotspotsUpdatedInUnreal = (
  sendMessageToUnreal: SendMessageToUnreal,
) => {
  sendMessageToUnreal({
    action: 'SPOTS_UPDATED',
    spots: [],
  });
};
